module.exports = __webpack_public_path__ + "img/bg3.4134688e.jpg";